module.exports = __webpack_public_path__ + "img/favicon.27bc69f9524c76c16b5b372c95465cd0.svg";